import React, { useEffect, useState } from 'react';

// import { Link } from 'react-router-dom';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

// import DesktopMenu from '../common/components/Navigation/DesktopMenu.js';

import Heading_Attendance from '../assets/images/Heading_Attendance.png';
import Heading_Payments from '../assets/images/Heading_Payments.png';
import Heading_TuitionRates from '../assets/images/Heading_TuitionRates.png';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { URL_ROOT } from '../common/globalConstants.js';
import { getTextBlocks } from '../common/globalMethods.js';

const Policies = (props) => {

	const {
		allTextBlocks,
		description,
		history,
		locationId,
		textBlocks,
		title
	} = props;

	const [pageTextBlocks, setPageTextBlocks] = useState([]);

	function listTextBlocks(currentPageTextBlocks, siteTextBlocks) {
		if(currentPageTextBlocks) {
			const currentTextBlocks = [];
			let matchingTextBlock = [];
			if(!Array.isArray(textBlocks)) {
				// eslint-disable-next-line
				matchingTextBlock = siteTextBlocks.filter(x => x.id == currentPageTextBlocks.TextBlockId);
				if(matchingTextBlock && matchingTextBlock.length === 1) {
					currentTextBlocks.push(matchingTextBlock[0]);
				}
			} else {
				const sortedTextBlocks = currentPageTextBlocks.sort((a, b) => (a.Order > b.Order) ? 1 : -1);

				for(let i = 0; i < sortedTextBlocks.length; i++) {
					// eslint-disable-next-line
					matchingTextBlock = siteTextBlocks.filter(x => x.id == sortedTextBlocks[i].TextBlockId);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				}
			}

			setPageTextBlocks(currentTextBlocks);
		}
	}

	useEffect(() => {
		if(allTextBlocks && allTextBlocks.length > 0) {
			listTextBlocks(textBlocks, allTextBlocks);
		} else if(textBlocks != null) {
			getTextBlocks()
			.then(response => {
				listTextBlocks(textBlocks, response);
			}).catch(error => {
				console.warn("Error", error);
			});
		} else {
			history.push(URL_ROOT);
		}
		// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
			<MetaTags>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:title" content={title} />
			</MetaTags>
			<Header locationId={locationId} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						{pageTextBlocks.map(pageTextBlock => {
							if(pageTextBlock.IsHtml) {
								return <div key={pageTextBlock.id} className='bodyHtml' dangerouslySetInnerHTML={{__html: pageTextBlock.BodyText}} />;
							} else {
								return <p key={pageTextBlock.id} className='bodyText'>{pageTextBlock.BodyText}</p>;
								}
							})}
							{// eslint-disable-next-line
								locationId == 0 && (
									<div id='policiesText'>
{/*
										<div id='tuitionSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_9892ae9e0588464a83fb6168bed893fb.jpg/v1/fill/w_949,h_159,al_c,lg_1,q_80/b2c0a7_9892ae9e0588464a83fb6168bed893fb.webp")'}}>
											<div className='imageOverlay'>
												<span>Tuition Rates</span>
											</div>
										</div>
*/}
										<img src={Heading_TuitionRates} title='Tuition Rates' alt='Tuition Rates' className='headingBanner' />
										<h2>Piano, Guitar, Bass, Ukulele, Flute, Clarinet, Saxophone, Trumpet and Voice</h2>
										<p>$130 a month for 30-minute lessons, weekly</p>
										<p>$185 a month for 45-minute lessons, weekly</p>
										<p>$240 a month for 60-minute lessons, weekly</p>
										<br />
										<p>All lessons with Lauren Canna</p>
										<p>$120 for 30-minute lessons, 3 lessons a month</p>
										<p>$160 for 45-minute lessons, 3 lessons a month</p>

										<h2>Homeschoolers</h2>
										<p>$110 a month, lessons scheduled before 3:00pm.</p>

										{/*
										<div id='paymentsSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_8d593067c85d4b0faad6491dd58bd224.jpg/v1/fill/w_929,h_159,al_c,lg_1,q_80/b2c0a7_8d593067c85d4b0faad6491dd58bd224.webp")'}}>
											<div className='imageOverlay'>
												<span>Payments</span>
											</div>
										</div>
										*/}

										<img src={Heading_Payments} title='Payments' alt='Payments'  className='headingBanner' />
										<p>Tuition is due by the first of the month for the upcoming month. A $30 late fee is applied for payments not made by the 10th of the month.</p>
										<p>Automatic Payment is available through our Current Client Portal.  You can safely add your credit/debit information, adjust the day your payment comes out, and change card accounts as needed.</p>
										<p>Credit/Debit - via monthly online invoice.  Processing fee is applied.</p>
										<p>Checks (recommended) - Clients submit a check for each month up to and including June.  If a student ends lessons before June, the unused checks will be destroyed or returned.   Please send checks to PO Box 345, Pitman NJ 08071</p>

										{/*
										<div id='attendanceSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_5f5a31a6e9204df8bd9b12605b6f95bb.jpg/v1/fill/w_929,h_150,al_c,q_80,usm_0.66_1.00_0.01/b2c0a7_5f5a31a6e9204df8bd9b12605b6f95bb.webp")'}}>
											<div className='imageOverlay'>
												<span>Attendance and Absences</span>
											</div>
										</div>
										*/}

										<img src={Heading_Attendance} title='Attendance and Absences' alt='Attendance and Absences' className='headingBanner' />
										<p>
											AfterSchool Music, like all regional music schools, operates on a flat-rate tuition structure.
											The total number of lessons per year are added up, divided by 12 months, and tuition remains the same every month throughout the year.
											There are 40 total lessons, with long vacation weeks at the December holidays, early June, and late August.
											Additional weeks off bookend the major holidays.
										</p>
										<p>
											Students reserve a time slot on our schedule that is exclusive to them.
											When a student cancels, they lose the benefit of that lesson time.
											However, absences communicated to us via email, absence form, or text before the lesson day can be rescheduled if a mutually agreeable time can be found within the teacher's schedule.
											There is no guarantee that a mutually agreeable time will be available, but we will do our best to inform you when/if a time opens up.
										</p>
										<p>
											Absences communicated on the lesson day itself or not communicated at all are not rescheduled.
										</p>
										<p>
											The teaching calendar is arranged so that students get the same number of yearly lessons regardless of the day they take lessons.
											Mid-week students will have some days where there are no lessons scheduled.
											This allows our mid-week and weekend students to all have the same number of lessons per year.
											It is important that our Saturday and Monday students receive the same amount of instruction time as our Tuesday, Wednesday, and Thursday students.
											We ask parents and students to be aware that there is no charge for lessons on days when we are closed mid-week.
										</p>
										<p>
											If a student ends their lessons before the month has ended, refunds are not extended on tuition.
										</p>
										<p>
											Please remember that one-on-one instruction with an adult who is fully invested in your child's development is something rare in a young person's life.
											Please take the steps necessary to ensure that team sports schedules work around your one-on-one lesson time.
											If a team advances and the schedule changes, talk with us and we will do what we can to accommodate the sudden change in your schedule.
										</p>

										<h2>Teacher Absence, Snow Days, School Closings</h2>
										<p>
											There are some days when we will need to cancel lessons.
											If we can reschedule the entire missed day for the same day of the week when we were to be closed, we will.
											For example, if we close for snow on a Thursday in January, we might reschedule that day for a Thursday during our Spring Break, or for the week preceding Memorial Day.
											When Pitman schools close for weather, we close.
											Our calendar is available on our website, please be aware of the days our school is closed.
											When we know ahead of time that a teacher will be out, we will try to reschedule or find an excellent substitute (often one of our other staff teachers will substitute).
											If we cannot find a substitute, we will contact you via text, email or both and issue a refund.
											When lessons are cancelled by us, a refund will show on your next invoice.
											For those who pay by check, we will issue a refund by check.
											If you are comfortable doing so, setting up a PayPal account will allow us to refund your account the same day.
										</p>

										<h2>Calendar</h2>
										<p>
											Lessons are held from the second week of September through the second week in June.
											Our summer session runs six weeks from July 5th through mid-August.
											Occasionally, to keep the number of lessons balanced for Saturday and Monday students, we will be closed on a weekday.
											We are closed on October 31st, Thanksgiving (Wed-Sun), the week of Christmas, the week after Christmas, the week after the New Year, President's Weekend, Easter week (Thurs-Wed), Memorial Day weekend and July 4th.
											We close on the two Saturdays of the Pitman Craft Fair because the whole street shuts down and it's impossible to reach our school.
										</p>

										<h2>Summer Lessons</h2>
										<p>
											Summer session is July 5th through mid-August.
											We've found that students who take off for the whole summer often spend too much time in fall 'catching up' to where they were back in June.
											A few summer lessons will keep students from losing progress.
											A dedicated student can make significant progress in the summer.
										</p>

										<h2>Rescheduling a lesson - short term</h2>
										<p>
											If you need to shift your lesson for a week or two, email us and we will let you know the times that are available.
											We will hold your original spot for up to two weeks.
											All verbal arrangements must be verified by email.
											Please do not ask your teacher to rearrange their schedule, please allow the office to make those adjustments.
										</p>

										<h2>Changing lesson time - long term</h2>
										<p>
											If you need to shift your lesson for three weeks or more, email us and we will let you know the times that are available.
											Your original spot may be filled, however, so please let us know if and when you would wish to switch back, we may be able to make it work.
										</p>

										<h2>Recitals</h2>
										<p>
											Recitals offer students an opportunity to perform for their families and peers.
											Recitals are short - about an hour - and very informal.
											We know how challenging it is to schedule recitals so we offer several recital times to choose from.
										</p>
									</div>
								)}
								{// eslint-disable-next-line
									locationId == 1 && (
										<div id='policiesText'>
											{/*
											<div id='tuitionSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_9892ae9e0588464a83fb6168bed893fb.jpg/v1/fill/w_949,h_159,al_c,lg_1,q_80/b2c0a7_9892ae9e0588464a83fb6168bed893fb.webp")'}}>
												<div className='imageOverlay'>
													<span>Tuition Rates</span>
												</div>
											</div>
											*/}

											<img src={Heading_TuitionRates} title='Tuition Rates' alt='Tuition Rates' className='headingBanner' />
											<h2>Piano, Guitar, Ukulele, Flute and Voice</h2>
											<p>$150 a month for 30-minute lessons, weekly</p>
											<p>$200 a month for 45-minute lessons, weekly</p>
											<p>$250 a month for 60-minute lessons, weekly</p>

											<h2>Summer Session</h2>
											<p>6 weeks July 5th through mid-August</p>
											<p>SIX LESSONS FOR THE PRICE OF A MONTH!</p>
											<p>$150 for 30-minute lessons.</p>
											<p>$200 for 45-minute lessons, weekly</p>
											<p>$250 for 60-minute lessons, weekly</p>
											<br />

											<p>Hometown Homies Bonus!</p>
											<p>If you refer a family within a 5-minute radius of your home to study either just before or just after your lesson, you will receive a sign-up bonus of $50 after their second month of lessons! </p>

											{/*
											<div id='paymentsSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_8d593067c85d4b0faad6491dd58bd224.jpg/v1/fill/w_929,h_159,al_c,lg_1,q_80/b2c0a7_8d593067c85d4b0faad6491dd58bd224.webp")'}}>
												<div className='imageOverlay'>
													<span>Payments</span>
												</div>
											</div>
											/*/}

											<img src={Heading_Payments} title='Payments' alt='Payments'  className='headingBanner' />
											<p>Tuition is due by the first of the month for the upcoming month. A $30 late fee is applied for payments not made by the 10th of the month.</p>
											<p>Credit/Debit - via monthly online invoice.  Processing fee is applied.</p>
											<p>Checks - Clients submit a check for each month up to and including June.  If a student ends lessons before June, the unused checks will be destroyed or returned.   Please send checks to PO Box 345, Pitman NJ 08071</p>
											<p>Teachers do not accept payments under any circumstances.</p>

											{/*
											<div id='attendanceSection' className='imageWithOverlay' style={{backgroundImage: 'url("https://static.wixstatic.com/media/b2c0a7_5f5a31a6e9204df8bd9b12605b6f95bb.jpg/v1/fill/w_929,h_150,al_c,q_80,usm_0.66_1.00_0.01/b2c0a7_5f5a31a6e9204df8bd9b12605b6f95bb.webp")'}}>
												<div className='imageOverlay'>
													<span>Attendance and Absences</span>
												</div>
											</div>
											*/}

											<img src={Heading_Attendance} title='Attendance and Absences' alt='Attendance and Absences' className='headingBanner' />
											<p>
												AfterSchool Music, like all regional music schools, operates on a flat-rate tuition structure. The total number of lessons per year are added up, divided by 10 months, and tuition remains the same every month from September-June - even if there are short months or holidays.
											</p>

											<p>
												Students reserve a time slot on our schedule that is exclusive to them. When a student cancels, they lose the benefit of that lesson time. However, absences communicated to us via email, absence form, or text before the lesson day can be rescheduled if a mutually agreeable time can be found within the teacher's schedule. There is no guarantee that a mutually agreeable time will be available, but we will do our best to inform you when/if a time opens up.
											</p>

											<p>
												Absences communicated on the lesson day itself or not communicated at all, are not rescheduled. The yearly calendar makes allowances for 3 lessons built into the tuition rate. If a student is absent fewer than 3 times a year, they will be getting some lessons for free.
											</p>

											<p>
												The teaching calendar is arranged so that students get the same number of yearly lessons regardless of the day they take lessons. Mid-week students will have some days where there are no lessons scheduled. This allows our mid-week and weekend students to all have the same number of lessons per year. It is important that our Saturday and Monday students receive the same amount of instruction time as our Tuesday, Wednesday, and Thursday students. We ask parents to be aware that there is no charge for lessons on days when we are closed mid-week.
											</p>
											<p>
												If a student ends their lessons before the month has ended, refunds are not extended on tuition.
											</p>
											<p>
												Please remember that one-on-one instruction with an adult who is fully invested in your child's development is something rare in a young person's life. Please take the steps necessary to ensure that team sports schedules work around your one-on-one lesson time. If a team advances and the schedule changes, talk with us and we will do what we can to accommodate the sudden change in your schedule.
											</p>

											<h2>Scheduling</h2>
											<p>
												Due to the nature of in-home lessons, teachers may be delayed due to traffic.  Teachers will do their best to keep you informed via text if they are running late.  We ask for your understanding in these circumstances.  If a teacher is delayed more than 60 minutes, the lesson will be cancelled and credited or refunded.  If a teacher is running early, they may ask if they may begin your lesson time early as well.  Do not feel obligated to agree - but if it is not an inconvenience, your teacher will appreciate your courtesy!  Because students are set up in a manner that allows for the teacher to travel conveniently from one house to the next, once a lesson time is established, it may be difficult to make changes due to other activities.  Please plan ahead for sports and other activities and choose a lesson day and time that will work from September through June.
											</p>

											<h2>Summer Lessons</h2>
											<p>
												Summer session is July 5th through mid-August. We've found that students who take off for the whole summer often spend too much time in fall 'catching up' to where they were back in June. A few summer lessons will keep students from losing progress. A dedicated student can make significant progress in the summer.
											</p>

											<h2>Rescheduling a lesson - short term</h2>
											<p>
												If you need to shift your lesson for a week or two, email us and we will let you know the times that are available. We will hold your original spot for up to two weeks. All verbal arrangements must be verified by email.
											</p>

											<h2>Changing lesson time - long term</h2>
											<p>
												If you need to shift your lesson for three weeks or more, email us and we will let you know the times that are available. Your original spot may be filled, however, so please let us know if and when you would wish to switch back, we may be able to make it work.
											</p>

											<h2>Recitals</h2>
											<p>
												Recitals offer students an opportunity to perform for their families and peers. Recitals are short - about an hour - and very informal. We know how challenging it is to schedule recitals so we offer several recital times to choose from.
											</p>
										</div>
									)}
								</div>
							</div>
						</main>
						<Footer locationId={locationId} />
					</React.Fragment>
				);
			};


			<div className='imageWithOverlay' style={{backgroundImage: 'url("")'}}>
				<div className='imageOverlay'>
					<span>Calendar, Summer, Teacher Absence, Rescheduling</span>
				</div>
			</div>

			const mapStateToProps = state => {
				return {
					allTextBlocks: state.application.textBlocks
				};
			};

			export default withRouter(connect(mapStateToProps, null)(Policies));
